import { render, staticRenderFns } from "./imgVerwaltung.vue?vue&type=template&id=b1ac7d9c&scoped=true"
import script from "./imgVerwaltung.vue?vue&type=script&lang=js"
export * from "./imgVerwaltung.vue?vue&type=script&lang=js"
import style0 from "./imgVerwaltung.vue?vue&type=style&index=0&id=b1ac7d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ac7d9c",
  null
  
)

export default component.exports